module.exports = __webpack_public_path__ + "60a5060413db535b58f9421642fcb3f0.svg";